export const  GET_PRODUCT_WOMEN_REQUEST ="GET_PRODUCT_WOMEN_REQUEST"
export const  GET_PRODUCT_WOMEN_SUCCESS ="GET_PRODUCT_WOMEN_SUCCESS"
export const  GET_PRODUCT_WOMEN_FAILURE ="GET_PRODUCT_WOMEN_FAILURE"

export const  GET_PRODUCT_MEN_REQUEST ="GET_PRODUCT_MEN_REQUEST"
export const  GET_PRODUCT_MEN_SUCCESS ="GET_PRODUCT_MEN_SUCCESS"
export const  GET_PRODUCT_MEN_FAILURE ="GET_PRODUCT_MEN_FAILURE"

export const  GET_PRODUCT_REQUEST ="GET_PRODUCT_REQUEST"
export const  GET_PRODUCT_SUCCESS ="GET_PRODUCT_SUCCESS"
export const  GET_PRODUCT_FAILURE ="GET_PRODUCT_FAILURE"
export const  GET_PRODUCT_SINGLE_MEN="GET_PRODUCT_SINGLE_MEN"
export const  GET_PRODUCT_SINGLE_WOMEN="GET_PRODUCT_SINGLE_WOMEN"


export const POST_PRODUCT_SUCCESS="POST_PRODUCT_SUCCESS"
export const PATCH_PRODUCT_SUCCESS="PATCH_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_SUCCESS="DELETE_PRODUCT_SUCCESS"
export const PRODUCT_REQUEST_FAILURE="PRODUCT_REQUEST_FAILURE"

export const CART_CHANGE = "CART_CHANGE"


export const USER_LOADING = "USER_LOADING"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS"
export const ADMIN_SUCCESS = "ADMIN_SUCCESS"
export const USER_FAIL = "USER_FAIL"
export const USER_LOGOUT = "USER_LOGOUT"

